module.exports = __webpack_public_path__ + "static/media/Analizci2.79f96ef1.png";